import { userService } from '../services/user.service.js'
import { router } from '../router.js'
import { getItem, clear } from './localStorage.js'

function safeJSONParse(value) {
  if (!value) return null
  if (typeof value === 'object') return value
  if (Array.isArray(value)) return value

  try {
    return JSON.parse(value)
  } catch (e) {
    console.warn('JSON parse error for value:', value)
    console.warn('Error:', e)
    return null
  }
}
var userParam = getItem('userParam') // userParam is already an object
var userMenu = getItem('userMenu') // userMenu is already an array
var loggeduser = safeJSONParse(getItem('loggeduser'))
var rights = safeJSONParse(getItem('rights'))

const state = loggeduser
  ? {
      status: { loggedIn: true },
      loggeduser,
      rights,
      userParam,
      userMenu,
      token: getItem('token') ? getItem('token') : null,
      dashboard: safeJSONParse(getItem('dashboard')) || {},
      emailConfirm: null,
    }
  : {
      status: {},
      loggeduser: null,
      rights: null,
      token: null,
      dashboard: null,
      userParam: null,
      userMenu: null,
      emailConfirm: null,
    }

export function loadUser() {
  try {
    const loggedUserData = getItem('loggeduser')
    const rightsData = getItem('rights')

    loggeduser = loggedUserData ? JSON.parse(loggedUserData) : null
    rights = rightsData ? JSON.parse(rightsData) : null

    // Ensure user ID exists
    if (loggeduser && !loggeduser.id) {
      console.warn('User data loaded but no ID found, resetting to null')
      loggeduser = null
    }
  } catch (error) {
    console.error('Error loading user data:', error)
    loggeduser = null
    rights = null
  }
}

const actions = {
  login({ dispatch, commit }, { username, password }) {
    commit('loginRequest', { username })

    userService.login(username, password).then(
      (user) => {
        commit('loginSuccess', user)
        router.push('/')
      },
      (error) => {
        commit('loginFailure', error)
        dispatch('alert/error', error, { root: true })
      }
    )
  },
  async logout({ commit }, redirectPath) {
    try {
      // First clear the state
      await commit('logout')

      // Then handle server-side logout
      await userService.logout()

      // Finally navigate
      if (redirectPath) {
        await router.push({
          name: 'login',
          query: {
            redirect: redirectPath,
          },
        })
      }
    } catch (error) {
      console.error('Error during logout:', error)
      // Force navigation to login page even if there was an error
      router.push({ name: 'login' })
    }
  },

  register({ dispatch, commit }, user) {
    commit('registerRequest', user)

    userService.register(user).then(
      (user) => {
        commit('registerSuccess', user)
        router.push('/')
        setTimeout(() => {
          dispatch('alert/success', 'Registration successful', { root: true })
        })
      },
      (error) => {
        commit('registerFailure', error)
        dispatch('alert/error', error, { root: true })
      }
    )
  },
  updateUserLocation({ commit }) {
    commit('updateLocation')
  },
}

const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true }
    state.loggeduser = user
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true }
    state.loggeduser = user
  },
  loginFailure(state) {
    state.status = {}
    state.loggeduser = null
  },
  logout(state) {
    // Reset state to initial empty values instead of null
    Object.assign(state, {
      status: {},
      loggeduser: null,
      rights: null,
      token: null,
      dashboard: null,
      userParam: null,
      userMenu: null,
      emailConfirm: null,
    })

    // Also clear localStorage
    clear()
  },
  updateLocation(state) {
    state.userLocation = navigator.language
  },
  updateUserParam(state, userParam) {
    state.userParam = userParam
  },
}

export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
}
